import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Special_Fee_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import { formatNumber } from "../../utils/formatNumber";

function Special_Fee_Report() {
    // 1. State Hooks
    const [feeData, setFeeData] = useState([]);
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");

    // 2. Fetch Logic
    const fetchInitialData = useCallback(async () => {
        setLoading(true);
        try {
            const payload = {
                customer_id: Number(localStorage.getItem("customer_id")) || 1005,
                api_key: localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
                language: "en",
                user_id: localStorage.getItem("user_id") || 14857,
                id: selectedCategory || 36 // Default ID from your snippet
            };

            const response = await simplePostCall(ApiConfig.specialfeereports, JSON.stringify(payload));

            if (response && response.result) {
                // Update the table data
                setFeeData(response.data || []);
                
                // Update the categories list for the dropdown if it's the first load
                if (response.category && categories.length === 0) {
                    setCategories(response.category);
                }
            }
        } catch (error) {
            console.error("Error fetching special fee report:", error);
        } finally {
            setLoading(false);
        }
    }, [selectedCategory, categories.length]);

    // Initial Load
    useEffect(() => {
        fetchInitialData();
    }, [fetchInitialData]);

    const handleSearch = (e) => {
        e.preventDefault();
        fetchInitialData();
    };

    return (
        <div className="special-fee-container" style={{ paddingTop: "25px" }}>
            <div className="special-fee-header">
                <h3>Special Fee Report</h3>
                <div className="export-btn-container-special">
                    <button className="export-btn-special">
                        Export <span className="arrow-down-special"></span>
                    </button>
                </div>
            </div>

            <div className="special-fee-body">
                {/* Filter Section */}
                <div className="filter-section-special">
                    <select 
                        className="parent-select-special"
                        value={selectedCategory}
                        onChange={(e) => setSelectedCategory(e.target.value)}
                    >
                        <option value="">Select Fee Category</option>
                        {categories.map((cat) => (
                            <option key={cat.fee_category_id} value={cat.fee_category_id}>
                                {cat.fee_category_name}
                            </option>
                        ))}
                    </select>
                    <button 
                        className="search-btn-special" 
                        onClick={handleSearch}
                        disabled={loading}
                    >
                        {loading ? "Searching..." : "Search"}
                    </button>
                </div>

                {/* Table */}
                <div className="table-container-special">
                    <table className="special-fee-table">
                        <thead>
                            <tr>
                                <th>Sr No</th>
                                <th>Invoice ID</th>
                                <th>Student</th>
                                <th>Academic Year</th>
                                <th>Demand Date</th>
                                <th>Amount Total</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {feeData.length > 0 ? (
                                feeData.map((item, index) => (
                                    <tr key={item.invoice_id}>
                                        <td>{index + 1}</td>
                                        <td>#{item.invoice_id}</td>
                                        <td>{item.student_name}</td>
                                        <td>{item.academic_year}</td>
                                        <td>{item.demand_date}</td>
                                        <td>{formatNumber(item.amount_total)}</td>
                                        <td>
                                            <span className={`status-badge ${item.status}`}>
                                                {item.status.toUpperCase()}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="no-results-special text-center">
                                        {loading ? "Loading..." : "No results found."}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Special_Fee_Report;